import { render, staticRenderFns } from "./settlement-form.vue?vue&type=template&id=77e5866e"
import script from "./settlement-form.vue?vue&type=script&lang=js"
export * from "./settlement-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports